import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
	selector: '[hlmSidebarMenuBadge],hlm-sidebar-menu-badge',
	exportAs: 'hlmSidebarMenuBadge',
	host: {
		'data-slot': 'sidebar-menu-badge',
		'data-sidebar': 'menu-badge',
	},
})
export class HlmSidebarMenuBadge {
	constructor() {
		classes(
			() =>
				'text-sidebar-foreground peer-hover/menu-button:text-sidebar-accent-foreground peer-data-active/menu-button:text-sidebar-accent-foreground pointer-events-none absolute end-1 h-5 min-w-5 rounded-md px-1 text-xs font-medium peer-data-[size=default]/menu-button:top-1.5 peer-data-[size=lg]/menu-button:top-2.5 peer-data-[size=sm]/menu-button:top-1 flex items-center justify-center tabular-nums select-none group-data-[collapsible=icon]:hidden',
		);
	}
}
